export default __webpack_public_path__ + "static/media/vertical_belonging.8a52d602.jpg";